// extracted by mini-css-extract-plugin
export default {"route":"PrivacyPolicy_route__j2Uex","wrapper":"PrivacyPolicy_wrapper__U+NYy"};